export enum TranslationType {
    SMS = 'SMS',
    FAQ = 'FAQ',
    DIRECTIONS = 'DIRECTIONS',
    CONTACT = 'CONTACT',
    LINK = 'LINK',
    CONTENT = 'CONTENT'
}

export enum TranslationLanguage {
    eng = 'eng',
    spa = 'spa',
    por = 'por',
    som = 'som',
}

export interface TranslationContentConstant {
    eng: string
    spa?: string
    som?: string
    zho?: string // this is not implemented in our constants and is only used for testing purposes
}

export type TranslationVars = {
    practice_name: string
    department_name: string
    appointment_time: string
    suggested_arrival_time: string
    has_doctor: boolean
    doctor_name: string
    doctor_telephone: string
    has_doctor_telephone: boolean
    appointment_link: string
}